import {api} from '../utils'

export default {
    getSummary: () => api.get('/evv/summary'),
    // The HHAeXchange payer codes a payer can carry; any other is refused.
    getPayerCodes: () => api.get('/evv/payer-codes'),
    getVisits: params => api.get('/evv/visits', {params}),
    getVisit: visitId => api.get(`/evv/visits/${visitId}`),
    reviewVisit: visitId => api.post(`/evv/visits/${visitId}/review`),
    resubmitVisit: visitId => api.post(`/evv/visits/${visitId}/resubmit`),
    escalateVisit: (visitId, data) => api.post(`/evv/visits/${visitId}/escalate`, data),
    cancelVisit: visitId => api.post(`/evv/visits/${visitId}/cancel`),
    bulkReviewVisits: data => api.post('/evv/visits/review', data),
    bulkResubmitVisits: data => api.post('/evv/visits/resubmit', data),
    bulkEscalateVisits: data => api.post('/evv/visits/escalate', data),
    bulkCancelVisits: data => api.post('/evv/visits/cancel', data),
}
